export default {"src":"/_next/static/media/world.bdb53e78.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};